"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGlobals = void 0;
const Actions = __importStar(require("../actions"));
const closure_1 = require("../closure");
const Values = __importStar(require("../value"));
const GlobalStore_1 = require("./GlobalStore");
let globals = undefined;
function useGlobals() {
    if (globals)
        return globals;
    globals = new GlobalStore_1.GlobalStore();
    globals.claim("Type", Values.Type());
    globals.define("Type", Values.Type());
    globals.claim("String", "Type");
    globals.define("String", Values.String());
    globals.claim("Trivial", "Type");
    globals.define("Trivial", Values.Trivial());
    globals.claim("sole", "Trivial");
    globals.define("sole", Values.Sole());
    globals.claim("Pair", "(A: Type, B: Type) -> Type");
    globals.define("Pair", "(A, B) => exists (A) B");
    globals.claim("car", `(
  implicit A: Type,
  implicit B: (x: A) -> Type,
  target: exists (x: A) B(x),
) -> A
`);
    globals.define("car", Values.FnImplicit((0, closure_1.ClosureNative)("A", (A) => Values.FnImplicit((0, closure_1.ClosureNative)("B", (B) => Values.Fn((0, closure_1.ClosureNative)("target", (target) => Actions.doCar(target))))))));
    globals.claim("cdr", `(
  implicit A: Type,
  implicit B: (x: A) -> Type,
  target: exists (x: A) B(x),
) -> B(car(target))
`);
    globals.define("cdr", Values.FnImplicit((0, closure_1.ClosureNative)("A", (A) => Values.FnImplicit((0, closure_1.ClosureNative)("B", (B) => Values.Fn((0, closure_1.ClosureNative)("target", (target) => Actions.doCdr(target))))))));
    globals.claim("the", "(T: Type, x: T) -> T");
    globals.define("the", "(T, x) => x");
    globals.claim("Equal", "(T: Type, from: T, to: T) -> Type");
    globals.define("Equal", Values.Fn((0, closure_1.ClosureNative)("T", (T) => Values.Fn((0, closure_1.ClosureNative)("from", (from) => Values.Fn((0, closure_1.ClosureNative)("to", (to) => Values.Equal(T, from, to))))))));
    globals.claim("refl", "(implicit T: Type, implicit x: T) -> Equal(T, x, x)");
    globals.define("refl", Values.FnImplicit((0, closure_1.ClosureNative)("T", (T) => Values.FnImplicit((0, closure_1.ClosureNative)("value", (value) => Values.Refl(T, value))))));
    globals.claim("same", "(implicit T: Type, x: T) -> Equal(T, x, x)");
    globals.define("same", Values.FnImplicit((0, closure_1.ClosureNative)("T", (T) => Values.Fn((0, closure_1.ClosureNative)("value", (value) => Values.Refl(T, value))))));
    globals.claim("replace", `(
  implicit T: Type,
  implicit from: T,
  implicit to: T,
  target: Equal(T, from, to),
  motive: (T) -> Type,
  base: motive(from),
) -> motive(to)
`);
    globals.define("replace", Values.FnImplicit((0, closure_1.ClosureNative)("T", (T) => Values.FnImplicit((0, closure_1.ClosureNative)("from", (from) => Values.FnImplicit((0, closure_1.ClosureNative)("to", (to) => Values.Fn((0, closure_1.ClosureNative)("target", (target) => Values.Fn((0, closure_1.ClosureNative)("motive", (motive) => Values.Fn((0, closure_1.ClosureNative)("base", (base) => Actions.doReplace(target, motive, base))))))))))))));
    globals.claim("equalMap", `(
  implicit X: Type,
  implicit Y: Type,
  implicit from: X,
  implicit to: X,
  f: (X) -> Y,
  target: Equal(X, from, to),
) -> Equal(Y, f(from), f(to))
`);
    globals.define("equalMap", `(
  implicit X,
  implicit Y,
  implicit from,
  implicit to,
  f,
  target,
) => {
  return replace(
    target,
    (x) => Equal(Y, f(from), f(x)),
    refl,
  )
}
`);
    globals.claim("equalSwap", `(
    implicit A: Type,
    implicit x: A,
    implicit y: A,
    xyEqual: Equal(A, x, y),
  ) -> Equal(A, y, x)
`);
    globals.define("equalSwap", `(
  implicit A,
  implicit x,
  implicit y,
  xyEqual,
) => {
  return replace(
    xyEqual,
    (w) => Equal(A, w, x),
    refl,
  )
}
`);
    globals.claim("equalCompose", `(
    implicit A: Type,
    implicit x: A,
    implicit y: A,
    implicit z: A,
    xyEqual: Equal(A, x, y),
    yzEqual: Equal(A, y, z),
  ) -> Equal(A, x, z)
`);
    globals.define("equalCompose", `(
  implicit A,
  implicit x,
  implicit y,
  implicit z,
  xyEqual,
  yzEqual,
) => {
  return replace(
    yzEqual,
    (w) => Equal(A, x, w),
    xyEqual,
  )
}
`);
    return globals;
}
exports.useGlobals = useGlobals;
//# sourceMappingURL=useGlobals.js.map